/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button } from '@coursera/coursera-ui';

import withSingleTracked from 'bundles/common/components/withSingleTracked';
import { findCueElementWithIndex } from 'bundles/interactive-transcript/utils/TranscriptHighlighterUtils';

const styles = () => css`
  left: 320px;
  z-index: 1000;
  margin-top: -40px;
  position: absolute;

  button {
    transition-property: background-color, border;
  }

  .transcript-highlight-btn-arrow-down {
    width: 0;
    height: 0;
    bottom: -10px;
    position: absolute;
    border-top: 20px solid #2a73cc;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    transition: border 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  }

  &:hover {
    .transcript-highlight-btn-arrow-down {
      border-top: 20px solid #0156b8;
    }
  }
`;

const TrackedButton = withSingleTracked({ type: 'BUTTON' })(Button);

type Props = {
  label: string;
  cueIndex: number;
  trackingName: string;
  onClick: () => void;
};

const TranscriptHighlightButton = ({ cueIndex, label, trackingName, onClick }: Props) => {
  const cueElement = findCueElementWithIndex(cueIndex);
  const cueOffsetTop = cueElement?.offsetTop;

  return (
    <div className="rc-TranscriptHighlightButton" style={{ top: cueOffsetTop }} css={styles}>
      <TrackedButton
        data-testid="transcriptHighlightButton"
        size="sm"
        label={label}
        type="primary"
        onClick={onClick}
        trackingName={trackingName}
        style={{ fontWeight: 'bold' }}
        // @ts-expect-error TODO: Property `tabIndex` does not exist on CUI `Button`. Move it to `htmlAttributes`
        tabIndex={-1}
      >
        <div className="transcript-highlight-btn-arrow-down" />
      </TrackedButton>
    </div>
  );
};

export default TranscriptHighlightButton;
